import "./FraudTicker.css";

const COMPANY_NAME = import.meta.env.VITE_COMPANY_NAME;
const REPAY_LINK = import.meta.env.VITE_WEBSITE_REPAY_LINK;

const TickerMessage = ({ hidden }: { hidden?: boolean }) => (
  <div className="lis-ticker-item" aria-hidden={hidden}>
    <svg className="lis-ticker-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2 1 21h22L12 2zm1 15h-2v-2h2v2zm0-4h-2V9h2v4z" />
    </svg>
    <span className="lis-ticker-label">Beware of frauds:</span>
    <span>
      Always use our secure{" "}
      <a
        href={REPAY_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="lis-ticker-link"
        tabIndex={hidden ? -1 : undefined}
      >
        Repayment on Website Link
      </a>{" "}
      for loan payments. Do not make direct bank payments to fake UPI links or
      unauthorised payment links. {COMPANY_NAME} is not responsible for
      payments made to other accounts.
    </span>
  </div>
);

const FraudTicker = () => {
  return (
    <>
      <div className="lis-ticker-spacer" />
      <div className="lis-ticker" role="marquee" aria-label="Fraud alert">
        <div className="lis-ticker-track">
          <TickerMessage />
          <TickerMessage hidden />
        </div>
      </div>
    </>
  );
};

export default FraudTicker;
